module.exports = __webpack_public_path__ + "img/how-to-fix-gbwhatsapp-not-installing.2b8bf43a.webp";